import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: ', ';\n  min-width: ', ';\n'], ['\n  display: ', ';\n  min-width: ', ';\n']);

import styled from 'styled-components';
import { isCollapsed } from '../../theme/util';

var getDisplay = function getDisplay(_ref) {
  var theme = _ref.theme,
      isDropdownTrigger = _ref.isDropdownTrigger;

  if (isDropdownTrigger && isCollapsed(theme)) {
    return 'none';
  }

  return 'block';
};

var NavigationItemAfter = styled.div(_templateObject, getDisplay, function (_ref2) {
  var shouldTakeSpace = _ref2.shouldTakeSpace;
  return shouldTakeSpace ? '24px' : 0;
});

NavigationItemAfter.displayName = 'NavigationItemAfter';
export default NavigationItemAfter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/NavigationItemAfter.js
// module id = 630
// module chunks = 0